import TopicRepository from "../repositories/TopicRepository";

export default class TopicService {

    static getAllAvailableTopics() {
        return TopicRepository.getAllAvailableTopics();
    }

    static getCoursesForUni(uniName: string) {
        return TopicRepository.getCoursesForUni(uniName);
    }

    static getOfferingsForCourse(courseCode: string) {
        return TopicRepository.getOfferingsForCourse(courseCode);
    }

    static getTopicsForOffering(offeringID: string) {
        return TopicRepository.getTopicsForOffering(offeringID);
    }

    static getExisitingTopics() {
        return TopicRepository.getExisitingTopics();
    }

    static renameTopic(oldTopic: string, newTopic: string) {
        return TopicRepository.renameTopic(oldTopic, newTopic);
    }

    static clearPointers() {
        TopicRepository.clearPointers();
    }

    static topicByID(ID: number) {
        return TopicRepository.topicByID(ID);
    }

    static topicByName(name: string) {
        return TopicRepository.topicByName(name);
    }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/services/TopicService.ts